import React, { useEffect, useState } from 'react';

import { toast, Toaster } from 'sonner';

export const FlashMessageCenter: React.FC = () => {
  useEffect(() => {
    const flashes = window.clutter.flash;
    if (!flashes) return;
    if (flashes.info) toast.info(flashes.info);
    if (flashes.danger) toast.error(flashes.danger);
    if (flashes.warning) toast.warning(flashes.warning);
  }, []);

  return <Toaster />;
};
